import { DESKTOP_NEWS_LIST_TITLE, MOBILE_NEWS_LIST_TITLE } from '@fe-news/constants/size/font';

export const fontStyles = (isDesktop: boolean) => {
  const fontSize = isDesktop ? DESKTOP_NEWS_LIST_TITLE : MOBILE_NEWS_LIST_TITLE;
  const lineHeight = isDesktop ? 1.6 : 1.5;
  const imageSize = isDesktop ? { width: 75, height: 53 } : { width: 85, height: 60 };

  return { fontSize, lineHeight, imageSize };
};
